import { TruncatedText } from 'components/common';

import { Flex } from '@project44/manifest-ds';

interface LocationCellProps {
  locationName: string;
  cityState: string;
}

const styles = {
  text: {
    width: '100%',
    lineHeight: 'normal',
  },
};

function LocationCell({ locationName, cityState }: LocationCellProps) {
  return (
    <Flex data-testid="location-cell" orientation="vertical" gap="x-small">
      <TruncatedText css={{ ...styles.text, fontWeight: '600' }}>
        {locationName || '-'}
      </TruncatedText>
      <TruncatedText css={styles.text}>{cityState || '-'}</TruncatedText>
    </Flex>
  );
}

export default LocationCell;
